import { connect } from "react-redux"
import React from "react"

import StakeholderEvidencePager from "./StakeholderEvidencePager"

export const StakeholderItemExpanded = props => (
    <div className="list-group stakeholder-item dimension-info">
        {props.toggleExpansion && (
            <span
                className="icon-close-filters"
                onClick={props.toggleExpansion()}
            >
                &times;
            </span>
        )}
        {props.type === "Organisation" ? (
            <h4 className="stakeholder-item-heading">{props.full_name}</h4>
        ) : (
            props.listItem
        )}
        <p className="stakeholder-item-bio">{props.bio}</p>
        <StakeholderEvidencePager
            roles={props.roles}
            stakeholderID={props.id}
        />
    </div>
)

const mapStateToProps = (
    { entities: { stakeholders }, presentation: { studio } },
    props
) => ({
    ...stakeholders[props.id],
    roles: stakeholders[props.id].roles.filter(
        role => role.linked_node.id === studio.activeId
    ),
    ...props
})

export default connect(mapStateToProps)(StakeholderItemExpanded)
